import BaseStore from 'core/stores/BaseStore';

class RoleStore extends BaseStore {
	constructor(rootStore) {
		super(rootStore.app.baasic.membershipModule.role);
	}
}

export default RoleStore;



// WEBPACK FOOTER //
// ./src/modules/role/stores/RoleStore.js